function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 16.476v2.71a1.805 1.805 0 0 1-1.974 1.807 17.933 17.933 0 0 1-7.81-2.773 17.63 17.63 0 0 1-5.43-5.42 17.852 17.852 0 0 1-2.779-7.83A1.804 1.804 0 0 1 4.808 3h2.715a1.81 1.81 0 0 1 1.81 1.554c.115.867.328 1.718.634 2.538.249.66.09 1.404-.407 1.906l-1.15 1.147a14.466 14.466 0 0 0 5.43 5.42l1.15-1.148a1.813 1.813 0 0 1 1.91-.406 11.64 11.64 0 0 0 2.543.632c.91.128 1.58.916 1.556 1.833z",
  stroke: "#2B9D8B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0335daa0.svg";
export { ForwardRef as ReactComponent };